var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	94499: {
		fallback: function() { return function() { return __webpack_require__(40961); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	32518: {
		fallback: function() { return function() { return __webpack_require__(47767); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.30.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router",

	},
	79357: {
		fallback: function() { return function() { return __webpack_require__(96540); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	38685: {
		fallback: function() { return function() { return __webpack_require__(48953); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.24.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@datadog/browser-rum",

	},
	598: {
		fallback: function() { return function() { return __webpack_require__(62040); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	},
	83208: {
		fallback: function() { return function() { return __webpack_require__(74848); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	53933: {
		fallback: function() { return function() { return __webpack_require__(72635); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^25.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "i18next",

	},
	89796: {
		fallback: function() { return function() { return __webpack_require__(5338); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	82556: {
		fallback: function() { return function() { return __webpack_require__(32389); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-i18next",

	},
	35869: {
		fallback: function() { return function() { return __webpack_require__(84447); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.13.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "axios",

	},
	44130: {
		fallback: function() { return function() { return __webpack_require__(84976); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.30.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	48894: {
		fallback: function() { return function() { return __webpack_require__(65848); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom/server",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [94499,32518,79357,38685,598,83208,53933,89796,82556,35869,44130,48894];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"76": [
		94499,
		32518
	],
	"524": [
		79357,
		38685,
		598,
		83208,
		53933,
		89796,
		82556,
		35869,
		44130,
		48894
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}